import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChartLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.483 14.05a1.614 1.614 0 1 1 0 .014zM10.812 8.513a1.615 1.615 0 1 1-3.23 0 1.615 1.615 0 0 1 3.23 0M20.609 8.513a1.615 1.615 0 1 1-3.23 0 1.615 1.615 0 0 1 3.23 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.874 9.67-2.681 3.199M5.314 13.054l2.792-3.358M13 12.875l-2.705-3.183M19.89 20.251h-14a2 2 0 0 1-2-2v-2.307"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.837 14.233a1.614 1.614 0 1 1-3.228 0 1.614 1.614 0 0 1 3.228 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.89 4.251v8.192"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgChartLine);
export default ForwardRef;
